export const twoDecimalsFilter = (num) => (+num).toFixed(2);

export const noDecimalsFilter = (num) => (+num).toFixed();

export const thousandsSeparatorFilter = (num) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
